import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchUserDetail = (userId) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchUserDetail = useCallback(async (id) => {
    if (!id) return;

    startLoading();
    const response = await apiGet(`/users/${userId}/details`, "Error al obtener el detalle del usuario");

    setResponse(response);
    return response?.data;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchUserDetail(userId);
  }, [userId, fetchUserDetail]);

  return { data, loading, error, refetch: () => fetchUserDetail(userId) };
};

export default useFetchUserDetail;
